import { Text } from "../../../../../../../../mads/Text";
import { useI18n } from "../../../../../../../../shared/I18n";
import { LocationTypeName } from "../../../constants/apiConstants";
import ViewJobLabelledContent from "../../common/ViewJobLabelledContent/ViewJobLabelledContent";

import React from "react";

export type RemoteLocationType = Exclude<
  LocationTypeName,
  LocationTypeName.PHYSICAL_LOCATION_TYPE_NAME
>;

export type RemoteLocation = {
  locationType: RemoteLocationType;
};

export type PhysicalLocation = {
  locationType: LocationTypeName.PHYSICAL_LOCATION_TYPE_NAME;
  address: string;
};
export interface LocationSectionProps {
  location: RemoteLocation | PhysicalLocation;
  interviewsOffered: boolean;
}

export const LocationSection: React.FC<LocationSectionProps> = ({
  location,
  interviewsOffered,
}) => {
  const gt = useI18n();

  let label: string;
  let content: string;
  if (interviewsOffered) {
    switch (location.locationType) {
      case LocationTypeName.PHYSICAL_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - in person interview",
          "In-person interview",
        );
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
        const physicalLocation = location as unknown as PhysicalLocation;
        content = physicalLocation.address;
        break;
      case LocationTypeName.VIP_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - virtual interview",
          "Virtual interview",
        );
        content = gt.pgettext(
          "View job overview - virtual interview - interview through indeed disclaimer",
          "The interview will take place on Indeed so you won't need to download anything.",
        );
        break;
      case LocationTypeName.PHONE_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - phone interview",
          "Phone interview",
        );
        content = gt.pgettext(
          "View job overview - phone interview - interview through indeed disclaimer",
          "You'll receive a phone call at the number you provide when signing up.",
        );
        break;
      case LocationTypeName.GENERIC_ONLINE_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - virtual interview",
          "Virtual interview",
        );
        content = gt.pgettext(
          "View job overview- virtual interview - sign up disclaimer",
          "Interview details will be provided after you sign up.",
        );
        break;
    }
  } else {
    switch (location.locationType) {
      case LocationTypeName.PHYSICAL_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - in person event",
          "In-person event",
        );
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
        const physicalLocation = location as unknown as PhysicalLocation;
        content = physicalLocation.address;
        break;
      case LocationTypeName.VIP_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - virtual event",
          "Virtual event",
        );
        content = gt.pgettext(
          "View job overview - virtual event - event through indeed disclaimer",
          "This event will take place on Indeed so you won’t need to download anything.",
        );
        break;
      case LocationTypeName.PHONE_LOCATION_TYPE_NAME:
        label = gt.pgettext("View job overview - in person or virtual - phone call", "Phone call");
        content = gt.pgettext(
          "View job overview - phone event - interview through indeed disclaimer",
          "You'll receive a phone call at the number you provide when signing up.",
        );
        break;
      case LocationTypeName.GENERIC_ONLINE_LOCATION_TYPE_NAME:
        label = gt.pgettext(
          "View job overview - in person or virtual - virtual event",
          "Virtual event",
        );
        content = gt.pgettext(
          "View job overview - virtual event - sign up disclaimer",
          "Event details will be provided after you sign up.",
        );
        break;
    }
  }

  return (
    <ViewJobLabelledContent label={label}>
      <Text level={3}>{content}</Text>
    </ViewJobLabelledContent>
  );
};
